class AddUserCtrl {

    constructor($scope, $uibModalInstance) {

        $scope.showBrowser = false;
        $scope.roles = ['ANALYTICS', 'CREATIVE', 'ADMIN', 'CLIENTADMIN'];
        if ($scope.$resolve.hasOwnProperty('user')) {
            $scope.item = $scope.$resolve.user;
            $scope.folder = { _id: null };
        } else {
            let previousLocation;
            if(!!localStorage.getItem("cpm.previousLocation")) {
                previousLocation = JSON.parse(localStorage.getItem("cpm.previousLocation"));
            }
            previousLocation = !!previousLocation ? previousLocation._id : $scope.$resolve.rootFolder;
            $scope.item = {
                securityRoles: ['USER'],
                rootFolder: previousLocation || "2129",
                folder: { _id: null }
            };
        }

        $scope.$watch('item.folder', (folder) => {
            if (folder != null && folder.id != null) {
                $scope.item.rootFolder = folder.id;
            }
        });

        this.$uibModalInstance = $uibModalInstance;
        this.$scope = $scope;
        this.$scope.ok = this.ok.bind(this);
        this.$scope.cancel = this.cancel.bind(this);
        this.$scope.toggleOption = this.toggleOption.bind(this);

    }

    toggleOption(name, array) {
        if (array.indexOf(name) > -1) {
            array.splice(array.indexOf(name), 1);
        } else {
            array.push(name);
        }
    }

    ok() {
        this.$uibModalInstance.close(this.$scope.item);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

angular.module("cpm").controller("AddUserCtrl", ['$scope', '$uibModalInstance', AddUserCtrl]);
